import { VideoPlayer } from "../atoms/video";
import { icon } from "../functions/icons";
import { InputFile } from "../atoms/input";

export function VideoModule({ src, className = "", style, onUpload }) {

   return (
    <div className={`video-module-container standard-margin-bottom ${className}`} style={style}>
      {src ? (
      <iframe
          src={src}
          title="Ingesloten video"
          width="100%"
          height="360"
          allow="autoplay; fullscreen"
          allowFullScreen
          style={{ border: "none", borderRadius: "calc(10px * var(--br-scale))"}}
        />
      ) : (
        <InputFile
          title=""
          verb="Klik om een video te uploaden"
          extraVerb="MP4 of MOV"
          accept="video/*"
          fileChange={onUpload}
          icon2="upload"
          placeholder={""}
        />
      )}
     
    </div>
  );
}